import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=7e974d7a&scoped=true&lang=pug&"
import script from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=7e974d7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e974d7a",
  null
  
)

export default component.exports